import { useFragment, graphql } from 'react-relay';
import { ArrayElement } from 'dibs-ts-utils/exports/ArrayElement';

import {
    usePayPalPaymentMethod_buyer$key,
    usePayPalPaymentMethod_buyer$data,
} from './__generated__/usePayPalPaymentMethod_buyer.graphql';

type usePayPalPaymentMethodArg = {
    buyer: usePayPalPaymentMethod_buyer$key;
};

type WalletPaymentMethod = NonNullable<
    ArrayElement<NonNullable<usePayPalPaymentMethod_buyer$data['wallet']>['paymentMethods']>
>;

type PaymentMethod = WalletPaymentMethod['paymentMethod'];
type PayPalAccount = Extract<PaymentMethod, { __typename: 'PayPalAccount' }>;

function isPayPalMethod(paymentMethod: PaymentMethod): paymentMethod is PayPalAccount {
    return !!paymentMethod && paymentMethod.__typename === 'PayPalAccount';
}

export function usePayPalPaymentMethod({ buyer: buyerRef }: usePayPalPaymentMethodArg): {
    token?: string | null;
    email?: string | null;
} {
    const buyer = useFragment(
        graphql`
            fragment usePayPalPaymentMethod_buyer on User {
                wallet {
                    paymentMethods {
                        paymentMethod {
                            __typename
                            ... on PayPalAccount {
                                paymentMethodType
                                token
                                email
                            }
                        }
                    }
                }
            }
        `,
        buyerRef
    );
    const paymentMethods = buyer?.wallet?.paymentMethods || [];
    let paymentMethod: PayPalAccount | undefined;
    for (const walletPaymentMethod of paymentMethods) {
        if (walletPaymentMethod && isPayPalMethod(walletPaymentMethod.paymentMethod)) {
            paymentMethod = walletPaymentMethod.paymentMethod;
            break;
        }
    }

    if (!paymentMethod) {
        return {};
    }
    return {
        token: paymentMethod.token,
        email: paymentMethod.email,
    };
}
